module.exports = "/static/assets/535f3a7d219eb20cefe55747d9e72749.png";